// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
} from '@hey-api/client-axios';
import type {
  GetProjectsByProjectIdContextsByContextIdCustomFieldsOocData,
  GetProjectsByProjectIdContextsByContextIdCustomFieldsOocError,
  GetProjectsByProjectIdContextsByContextIdCustomFieldsOocResponse,
  PostProjectsByProjectIdContextsByContextIdCustomFieldsData,
  PostProjectsByProjectIdContextsByContextIdCustomFieldsError,
  PostProjectsByProjectIdContextsByContextIdCustomFieldsResponse,
  DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdData,
  DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdError,
  DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdResponse,
  PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdData,
  PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdError,
  PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdResponse,
  GetUsersError,
  GetUsersResponse,
  GetUsersByUserIdProjectsByProjectIdRoleData,
  GetUsersByUserIdProjectsByProjectIdRoleError,
  GetUsersByUserIdProjectsByProjectIdRoleResponse,
  GetUsersByUserIdIsAdminData,
  GetUsersByUserIdIsAdminError,
  GetUsersByUserIdIsAdminResponse,
  GetSyntaxesError,
  GetSyntaxesResponse,
  GetSyntaxesBySyntaxIdData,
  GetSyntaxesBySyntaxIdError,
  GetSyntaxesBySyntaxIdResponse,
  PostProjectsData,
  PostProjectsError,
  PostProjectsResponse,
  GetProjectsData,
  GetProjectsError,
  GetProjectsResponse,
  DeleteProjectsByProjectIdData,
  DeleteProjectsByProjectIdError,
  DeleteProjectsByProjectIdResponse,
  PatchProjectsByProjectIdData,
  PatchProjectsByProjectIdError,
  PatchProjectsByProjectIdResponse,
  PostProjectsByProjectIdArchiveData,
  PostProjectsByProjectIdArchiveError,
  PostProjectsByProjectIdArchiveResponse,
  PostProjectsByProjectIdRestoreData,
  PostProjectsByProjectIdRestoreError,
  PostProjectsByProjectIdRestoreResponse,
  GetProjectsByProjectIdOwnersData,
  GetProjectsByProjectIdOwnersError,
  GetProjectsByProjectIdOwnersResponse,
  PostProjectsByProjectIdOwnersData,
  PostProjectsByProjectIdOwnersError,
  PostProjectsByProjectIdOwnersResponse,
  PatchProjectsByProjectIdOwnersByOwnerIdData,
  PatchProjectsByProjectIdOwnersByOwnerIdError,
  PatchProjectsByProjectIdOwnersByOwnerIdResponse,
  DeleteProjectsByProjectIdOwnersByOwnerIdData,
  DeleteProjectsByProjectIdOwnersByOwnerIdError,
  DeleteProjectsByProjectIdOwnersByOwnerIdResponse,
  GetProjectsByProjectIdOwnergroupsData,
  GetProjectsByProjectIdOwnergroupsError,
  GetProjectsByProjectIdOwnergroupsResponse,
  PostProjectsByProjectIdOwnergroupsData,
  PostProjectsByProjectIdOwnergroupsError,
  PostProjectsByProjectIdOwnergroupsResponse,
  PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdData,
  PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdError,
  PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdResponse,
  DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdData,
  DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdError,
  DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdResponse,
  GetProjectsByProjectIdContextsByContextIdOocByOocIdData,
  GetProjectsByProjectIdContextsByContextIdOocByOocIdError,
  GetProjectsByProjectIdContextsByContextIdOocByOocIdResponse,
  GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesData,
  GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesError,
  GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesResponse,
  PostProjectsByProjectIdContextsByContextIdOocData,
  PostProjectsByProjectIdContextsByContextIdOocError,
  PostProjectsByProjectIdContextsByContextIdOocResponse,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteData,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteError,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteResponse,
  PostProjectsByProjectIdContextsByContextIdOocBatchDeleteData,
  PostProjectsByProjectIdContextsByContextIdOocBatchDeleteError,
  PostProjectsByProjectIdContextsByContextIdOocBatchDeleteResponse,
  PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerData,
  PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerError,
  PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerResponse,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameData,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameError,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameResponse,
  PatchProjectsByProjectIdContextsByContextIdOocColorData,
  PatchProjectsByProjectIdContextsByContextIdOocColorError,
  PatchProjectsByProjectIdContextsByContextIdOocColorResponse,
  PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueData,
  PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueError,
  PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueResponse,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeData,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeError,
  PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeResponse,
  PatchProjectsByProjectIdContextsByContextIdOocPositionData,
  PatchProjectsByProjectIdContextsByContextIdOocPositionError,
  PatchProjectsByProjectIdContextsByContextIdOocPositionResponse,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateData,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateError,
  PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateResponse,
  GetNotificationsError,
  GetNotificationsResponse,
  GetProjectsByProjectIdContextsByContextIdN2ObjectsData,
  GetProjectsByProjectIdContextsByContextIdN2ObjectsError,
  GetProjectsByProjectIdContextsByContextIdN2ObjectsResponse,
  PostProjectsByProjectIdContextsByContextIdN2InterfacesData,
  PostProjectsByProjectIdContextsByContextIdN2InterfacesError,
  PostProjectsByProjectIdContextsByContextIdN2InterfacesResponse,
  PostProjectsByProjectIdContextsByContextIdN2MicroData,
  PostProjectsByProjectIdContextsByContextIdN2MicroError,
  PostProjectsByProjectIdContextsByContextIdN2MicroResponse,
  GetProjectsByProjectIdMilestonesData,
  GetProjectsByProjectIdMilestonesError,
  GetProjectsByProjectIdMilestonesResponse,
  PostProjectsByProjectIdMilestonesData,
  PostProjectsByProjectIdMilestonesError,
  PostProjectsByProjectIdMilestonesResponse,
  GetProjectsByProjectIdMilestonesMeData,
  GetProjectsByProjectIdMilestonesMeError,
  GetProjectsByProjectIdMilestonesMeResponse,
  GetProjectsByProjectIdMilestonesByMilestoneIdData,
  GetProjectsByProjectIdMilestonesByMilestoneIdError,
  GetProjectsByProjectIdMilestonesByMilestoneIdResponse,
  PatchProjectsByProjectIdMilestonesByMilestoneIdData,
  PatchProjectsByProjectIdMilestonesByMilestoneIdError,
  PatchProjectsByProjectIdMilestonesByMilestoneIdResponse,
  DeleteProjectsByProjectIdMilestonesByMilestoneIdData,
  DeleteProjectsByProjectIdMilestonesByMilestoneIdError,
  DeleteProjectsByProjectIdMilestonesByMilestoneIdResponse,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutData,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutError,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutResponse,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinData,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinError,
  PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinResponse,
  PostMeetingplannerByProjectIdByContextData,
  PostMeetingplannerByProjectIdByContextError,
  PostMeetingplannerByProjectIdByContextResponse,
  PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneData,
  PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneError,
  PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneResponse,
  PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneData,
  PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneError,
  PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneResponse,
  GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocData,
  GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocError,
  GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocResponse,
  PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneData,
  PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneError,
  PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneResponse,
  DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneData,
  DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneError,
  DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneResponse,
  GetExportByIdData,
  GetExportByIdError,
  GetExportByIdResponse,
  GetExportByIdExcelData,
  GetExportByIdExcelError,
  GetExportByIdExcelResponse,
  PostProjectsByProjectIdByContextIdCoreExportData,
  PostProjectsByProjectIdByContextIdCoreExportError,
  PostProjectsByProjectIdByContextIdCoreExportResponse,
  PostDomaByProjectIdExportData,
  PostDomaByProjectIdExportError,
  PostDomaByProjectIdExportResponse,
  PostProjectsByProjectIdByContextIdSimoExportData,
  PostProjectsByProjectIdByContextIdSimoExportError,
  PostProjectsByProjectIdByContextIdSimoExportResponse,
  GetLogsData,
  GetLogsError,
  GetLogsResponse,
  GetProjectsByProjectIdLogsData,
  GetProjectsByProjectIdLogsError,
  GetProjectsByProjectIdLogsResponse,
  GetProjectsByProjectIdContextsData,
  GetProjectsByProjectIdContextsError,
  GetProjectsByProjectIdContextsResponse,
  PostProjectsByProjectIdContextsData,
  PostProjectsByProjectIdContextsError,
  PostProjectsByProjectIdContextsResponse,
  GetContextAsyncData,
  GetContextAsyncError,
  GetContextAsyncResponse,
  PatchProjectsByProjectIdContextsByContextIdData,
  PatchProjectsByProjectIdContextsByContextIdError,
  PatchProjectsByProjectIdContextsByContextIdResponse,
  DeleteProjectsByProjectIdContextsByContextIdData,
  DeleteProjectsByProjectIdContextsByContextIdError,
  DeleteProjectsByProjectIdContextsByContextIdResponse,
  GetProjectsByProjectIdContextsByContextIdStructureNestedData,
  GetProjectsByProjectIdContextsByContextIdStructureNestedError,
  GetProjectsByProjectIdContextsByContextIdStructureNestedResponse,
  GetProjectsByProjectIdContextsByContextIdStructureFlatData,
  GetProjectsByProjectIdContextsByContextIdStructureFlatError,
  GetProjectsByProjectIdContextsByContextIdStructureFlatResponse,
  GetProjectsByProjectIdContextsByContextIdStructureDepthData,
  GetProjectsByProjectIdContextsByContextIdStructureDepthError,
  GetProjectsByProjectIdContextsByContextIdStructureDepthResponse,
  GetProjectsByProjectIdContextsCreationInfoData,
  GetProjectsByProjectIdContextsCreationInfoError,
  GetProjectsByProjectIdContextsCreationInfoResponse,
  PostProjectsByProjectIdContextsByContextIdArchiveData,
  PostProjectsByProjectIdContextsByContextIdArchiveError,
  PostProjectsByProjectIdContextsByContextIdArchiveResponse,
  PostProjectsByProjectIdContextsByContextIdRestoreData,
  PostProjectsByProjectIdContextsByContextIdRestoreError,
  PostProjectsByProjectIdContextsByContextIdRestoreResponse,
  GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupData,
  GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupError,
  GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupResponse,
  GetClassificationTablesData,
  GetClassificationTablesError,
  GetClassificationTablesResponse,
  GetClassificationTablesByClassificationTableIdData,
  GetClassificationTablesByClassificationTableIdError,
  GetClassificationTablesByClassificationTableIdResponse,
  GetClassificationsEntriesByClassificationEntryIdData,
  GetClassificationsEntriesByClassificationEntryIdError,
  GetClassificationsEntriesByClassificationEntryIdResponse,
} from './types.gen';

export const client = createClient(createConfig());

export const getProjectsByProjectIdContextsByContextIdCustomFieldsOoc = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdCustomFieldsOocData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdCustomFieldsOocResponse,
    GetProjectsByProjectIdContextsByContextIdCustomFieldsOocError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/custom-fields/ooc',
  });
};

export const postProjectsByProjectIdContextsByContextIdCustomFields = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdCustomFieldsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdCustomFieldsResponse,
    PostProjectsByProjectIdContextsByContextIdCustomFieldsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/custom-fields',
  });
};

export const deleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).delete<
      DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdResponse,
      DeleteProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/contexts/{contextId}/custom-fields/{customFieldId}',
    });
  };

export const putProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldId =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).put<
      PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdResponse,
      PutProjectsByProjectIdContextsByContextIdCustomFieldsByCustomFieldIdError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/contexts/{contextId}/custom-fields/{customFieldId}',
    });
  };

export const getUsers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUsersResponse,
    GetUsersError,
    ThrowOnError
  >({
    ...options,
    url: '/users',
  });
};

export const getUsersByUserIdProjectsByProjectIdRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsersByUserIdProjectsByProjectIdRoleData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUsersByUserIdProjectsByProjectIdRoleResponse,
    GetUsersByUserIdProjectsByProjectIdRoleError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{userId}/projects/{projectId}/role',
  });
};

export const getUsersByUserIdIsAdmin = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByUserIdIsAdminData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUsersByUserIdIsAdminResponse,
    GetUsersByUserIdIsAdminError,
    ThrowOnError
  >({
    ...options,
    url: '/users/{userId}/is-admin',
  });
};

export const getSyntaxes = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSyntaxesResponse,
    GetSyntaxesError,
    ThrowOnError
  >({
    ...options,
    url: '/syntaxes',
  });
};

export const getSyntaxesBySyntaxId = <ThrowOnError extends boolean = false>(
  options: Options<GetSyntaxesBySyntaxIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetSyntaxesBySyntaxIdResponse,
    GetSyntaxesBySyntaxIdError,
    ThrowOnError
  >({
    ...options,
    url: '/syntaxes/{syntaxId}',
  });
};

export const postProjects = <ThrowOnError extends boolean = false>(
  options: Options<PostProjectsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsResponse,
    PostProjectsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects',
  });
};

export const getProjects = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsResponse,
    GetProjectsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects',
  });
};

export const deleteProjectsByProjectId = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectsByProjectIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteProjectsByProjectIdResponse,
    DeleteProjectsByProjectIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}',
  });
};

export const patchProjectsByProjectId = <ThrowOnError extends boolean = false>(
  options: Options<PatchProjectsByProjectIdData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdResponse,
    PatchProjectsByProjectIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}',
  });
};

export const postProjectsByProjectIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdArchiveData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdArchiveResponse,
    PostProjectsByProjectIdArchiveError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/archive',
  });
};

export const postProjectsByProjectIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdRestoreData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdRestoreResponse,
    PostProjectsByProjectIdRestoreError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/restore',
  });
};

export const getProjectsByProjectIdOwners = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdOwnersData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdOwnersResponse,
    GetProjectsByProjectIdOwnersError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/owners',
  });
};

export const postProjectsByProjectIdOwners = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdOwnersData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdOwnersResponse,
    PostProjectsByProjectIdOwnersError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/owners',
  });
};

export const patchProjectsByProjectIdOwnersByOwnerId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchProjectsByProjectIdOwnersByOwnerIdData, ThrowOnError>
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdOwnersByOwnerIdResponse,
    PatchProjectsByProjectIdOwnersByOwnerIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/owners/{ownerId}',
  });
};

export const deleteProjectsByProjectIdOwnersByOwnerId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdOwnersByOwnerIdData, ThrowOnError>
) => {
  return (options?.client ?? client).delete<
    DeleteProjectsByProjectIdOwnersByOwnerIdResponse,
    DeleteProjectsByProjectIdOwnersByOwnerIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/owners/{ownerId}',
  });
};

export const getProjectsByProjectIdOwnergroups = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdOwnergroupsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdOwnergroupsResponse,
    GetProjectsByProjectIdOwnergroupsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/ownergroups',
  });
};

export const postProjectsByProjectIdOwnergroups = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdOwnergroupsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdOwnergroupsResponse,
    PostProjectsByProjectIdOwnergroupsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/ownergroups',
  });
};

export const patchProjectsByProjectIdOwnergroupsByOwnerGroupId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdResponse,
    PatchProjectsByProjectIdOwnergroupsByOwnerGroupIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/ownergroups/{ownerGroupId}',
  });
};

export const deleteProjectsByProjectIdOwnergroupsByOwnerGroupId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdResponse,
    DeleteProjectsByProjectIdOwnergroupsByOwnerGroupIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/ownergroups/{ownerGroupId}',
  });
};

export const getProjectsByProjectIdContextsByContextIdOocByOocId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdOocByOocIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdOocByOocIdResponse,
    GetProjectsByProjectIdContextsByContextIdOocByOocIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}',
  });
};

export const getProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntries =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).get<
      GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesResponse,
      GetProjectsByProjectIdContextsByContextIdOocByOocParentIdAllowedRdsEntriesError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocParentId}/allowed-rds-entries',
    });
  };

export const postProjectsByProjectIdContextsByContextIdOoc = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdOocData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdOocResponse,
    PostProjectsByProjectIdContextsByContextIdOocError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc',
  });
};

export const postProjectsByProjectIdContextsByContextIdOocByOocIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteResponse,
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}/delete',
  });
};

export const postProjectsByProjectIdContextsByContextIdOocBatchDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdOocBatchDeleteData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdOocBatchDeleteResponse,
    PostProjectsByProjectIdContextsByContextIdOocBatchDeleteError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/batch/delete',
  });
};

export const postProjectsByProjectIdContextsByContextIdOocBatchAssignOwner = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerResponse,
    PostProjectsByProjectIdContextsByContextIdOocBatchAssignOwnerError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/batch/assign-owner',
  });
};

export const patchProjectsByProjectIdContextsByContextIdOocByOocIdName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameResponse,
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdNameError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}/name',
  });
};

export const patchProjectsByProjectIdContextsByContextIdOocColor = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdContextsByContextIdOocColorData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdContextsByContextIdOocColorResponse,
    PatchProjectsByProjectIdContextsByContextIdOocColorError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/color',
  });
};

export const putProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValue =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).put<
      PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueResponse,
      PutProjectsByProjectIdContextsByContextIdOocByOocIdCustomFieldValueError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}/custom-field-value',
    });
  };

export const patchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeResponse,
    PatchProjectsByProjectIdContextsByContextIdOocByOocIdRdsCodeError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}/rds-code',
  });
};

export const patchProjectsByProjectIdContextsByContextIdOocPosition = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdContextsByContextIdOocPositionData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdContextsByContextIdOocPositionResponse,
    PatchProjectsByProjectIdContextsByContextIdOocPositionError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/position',
  });
};

export const postProjectsByProjectIdContextsByContextIdOocByOocIdDuplicate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateResponse,
    PostProjectsByProjectIdContextsByContextIdOocByOocIdDuplicateError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/ooc/{oocId}/duplicate',
  });
};

export const getNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetNotificationsResponse,
    GetNotificationsError,
    ThrowOnError
  >({
    ...options,
    url: '/notifications',
  });
};

export const getProjectsByProjectIdContextsByContextIdN2Objects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdN2ObjectsData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdN2ObjectsResponse,
    GetProjectsByProjectIdContextsByContextIdN2ObjectsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/n2/objects',
  });
};

export const postProjectsByProjectIdContextsByContextIdN2Interfaces = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdN2InterfacesData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdN2InterfacesResponse,
    PostProjectsByProjectIdContextsByContextIdN2InterfacesError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/n2/interfaces',
  });
};

export const postProjectsByProjectIdContextsByContextIdN2Micro = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdN2MicroData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdN2MicroResponse,
    PostProjectsByProjectIdContextsByContextIdN2MicroError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/n2/micro',
  });
};

export const getProjectsByProjectIdMilestones = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdMilestonesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdMilestonesResponse,
    GetProjectsByProjectIdMilestonesError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones',
  });
};

export const postProjectsByProjectIdMilestones = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdMilestonesData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdMilestonesResponse,
    PostProjectsByProjectIdMilestonesError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones',
  });
};

export const getProjectsByProjectIdMilestonesMe = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdMilestonesMeData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdMilestonesMeResponse,
    GetProjectsByProjectIdMilestonesMeError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/me',
  });
};

export const getProjectsByProjectIdMilestonesByMilestoneId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdMilestonesByMilestoneIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdMilestonesByMilestoneIdResponse,
    GetProjectsByProjectIdMilestonesByMilestoneIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/{milestone_id}',
  });
};

export const patchProjectsByProjectIdMilestonesByMilestoneId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdMilestonesByMilestoneIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdMilestonesByMilestoneIdResponse,
    PatchProjectsByProjectIdMilestonesByMilestoneIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/{milestone_id}',
  });
};

export const deleteProjectsByProjectIdMilestonesByMilestoneId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProjectsByProjectIdMilestonesByMilestoneIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    DeleteProjectsByProjectIdMilestonesByMilestoneIdResponse,
    DeleteProjectsByProjectIdMilestonesByMilestoneIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/{milestone_id}',
  });
};

export const putProjectsByProjectIdMilestonesMeByMilestoneIdOptout = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).put<
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutResponse,
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptoutError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/me/{milestone_id}/optout',
  });
};

export const putProjectsByProjectIdMilestonesMeByMilestoneIdOptin = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).put<
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinResponse,
    PutProjectsByProjectIdMilestonesMeByMilestoneIdOptinError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/milestones/me/{milestone_id}/optin',
  });
};

export const postMeetingplannerByProjectIdByContext = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostMeetingplannerByProjectIdByContextData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostMeetingplannerByProjectIdByContextResponse,
    PostMeetingplannerByProjectIdByContextError,
    ThrowOnError
  >({
    ...options,
    url: '/meetingplanner/{projectId}/{context}',
  });
};

export const postProjectsByProjectIdByContextIdSimoBatchRemovemilestone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneResponse,
    PostProjectsByProjectIdByContextIdSimoBatchRemovemilestoneError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/{contextId}/simo/batch/removemilestone',
  });
};

export const postProjectsByProjectIdByContextIdSimoBatchAddmilestone = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneResponse,
    PostProjectsByProjectIdByContextIdSimoBatchAddmilestoneError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/{contextId}/simo/batch/addmilestone',
  });
};

export const getProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOoc =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).get<
      GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocResponse,
      GetProjectsByProjectIdByContextIdSimoPointBySourceOocByTargetOocError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/{contextId}/simo/point/{source_ooc}/{target_ooc}',
    });
  };

export const putProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestone =
  <ThrowOnError extends boolean = false>(
    options: Options<
      PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).put<
      PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneResponse,
      PutProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/{contextId}/simo/interfaces/{interface}/milestones/{milestone}',
    });
  };

export const deleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestone =
  <ThrowOnError extends boolean = false>(
    options: Options<
      DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).delete<
      DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneResponse,
      DeleteProjectsByProjectIdByContextIdSimoInterfacesByInterfaceMilestonesByMilestoneError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/{contextId}/simo/interfaces/{interface}/milestones/{milestone}',
    });
  };

export const getExportById = <ThrowOnError extends boolean = false>(
  options: Options<GetExportByIdData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExportByIdResponse,
    GetExportByIdError,
    ThrowOnError
  >({
    ...options,
    url: '/export/{id}',
  });
};

export const getExportByIdExcel = <ThrowOnError extends boolean = false>(
  options: Options<GetExportByIdExcelData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetExportByIdExcelResponse,
    GetExportByIdExcelError,
    ThrowOnError
  >({
    ...options,
    url: '/export/{id}/excel',
  });
};

export const postProjectsByProjectIdByContextIdCoreExport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdByContextIdCoreExportData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdByContextIdCoreExportResponse,
    PostProjectsByProjectIdByContextIdCoreExportError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/{contextId}/core/export',
  });
};

export const postDomaByProjectIdExport = <ThrowOnError extends boolean = false>(
  options: Options<PostDomaByProjectIdExportData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostDomaByProjectIdExportResponse,
    PostDomaByProjectIdExportError,
    ThrowOnError
  >({
    ...options,
    url: '/doma/{projectId}/export',
  });
};

export const postProjectsByProjectIdByContextIdSimoExport = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdByContextIdSimoExportData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdByContextIdSimoExportResponse,
    PostProjectsByProjectIdByContextIdSimoExportError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/{contextId}/simo/export',
  });
};

export const getLogs = <ThrowOnError extends boolean = false>(
  options?: Options<GetLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetLogsResponse,
    GetLogsError,
    ThrowOnError
  >({
    ...options,
    url: '/logs',
  });
};

export const getProjectsByProjectIdLogs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdLogsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdLogsResponse,
    GetProjectsByProjectIdLogsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/logs',
  });
};

export const getProjectsByProjectIdContexts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdContextsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsResponse,
    GetProjectsByProjectIdContextsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts',
  });
};

export const postProjectsByProjectIdContexts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdContextsData, ThrowOnError>
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsResponse,
    PostProjectsByProjectIdContextsError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts',
  });
};

export const getContextAsync = <ThrowOnError extends boolean = false>(
  options: Options<GetContextAsyncData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetContextAsyncResponse,
    GetContextAsyncError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}',
  });
};

export const patchProjectsByProjectIdContextsByContextId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PatchProjectsByProjectIdContextsByContextIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).patch<
    PatchProjectsByProjectIdContextsByContextIdResponse,
    PatchProjectsByProjectIdContextsByContextIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}',
  });
};

export const deleteProjectsByProjectIdContextsByContextId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteProjectsByProjectIdContextsByContextIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).delete<
    DeleteProjectsByProjectIdContextsByContextIdResponse,
    DeleteProjectsByProjectIdContextsByContextIdError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}',
  });
};

export const getProjectsByProjectIdContextsByContextIdStructureNested = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdStructureNestedData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdStructureNestedResponse,
    GetProjectsByProjectIdContextsByContextIdStructureNestedError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/structure/nested',
  });
};

export const getProjectsByProjectIdContextsByContextIdStructureFlat = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdStructureFlatData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdStructureFlatResponse,
    GetProjectsByProjectIdContextsByContextIdStructureFlatError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/structure/flat',
  });
};

export const getProjectsByProjectIdContextsByContextIdStructureDepth = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdContextsByContextIdStructureDepthData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsByContextIdStructureDepthResponse,
    GetProjectsByProjectIdContextsByContextIdStructureDepthError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/structure/depth',
  });
};

export const getProjectsByProjectIdContextsCreationInfo = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdContextsCreationInfoData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetProjectsByProjectIdContextsCreationInfoResponse,
    GetProjectsByProjectIdContextsCreationInfoError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/creation-info',
  });
};

export const postProjectsByProjectIdContextsByContextIdArchive = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdArchiveData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdArchiveResponse,
    PostProjectsByProjectIdContextsByContextIdArchiveError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/archive',
  });
};

export const postProjectsByProjectIdContextsByContextIdRestore = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PostProjectsByProjectIdContextsByContextIdRestoreData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).post<
    PostProjectsByProjectIdContextsByContextIdRestoreResponse,
    PostProjectsByProjectIdContextsByContextIdRestoreError,
    ThrowOnError
  >({
    ...options,
    url: '/projects/{projectId}/contexts/{contextId}/restore',
  });
};

export const getProjectsByProjectIdContextsByContextIdClassificationTablesLookup =
  <ThrowOnError extends boolean = false>(
    options: Options<
      GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupData,
      ThrowOnError
    >
  ) => {
    return (options?.client ?? client).get<
      GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupResponse,
      GetProjectsByProjectIdContextsByContextIdClassificationTablesLookupError,
      ThrowOnError
    >({
      ...options,
      url: '/projects/{projectId}/contexts/{contextId}/classification-tables-lookup',
    });
  };

export const getClassificationTables = <ThrowOnError extends boolean = false>(
  options?: Options<GetClassificationTablesData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetClassificationTablesResponse,
    GetClassificationTablesError,
    ThrowOnError
  >({
    ...options,
    url: '/classification-tables',
  });
};

export const getClassificationTablesByClassificationTableId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetClassificationTablesByClassificationTableIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetClassificationTablesByClassificationTableIdResponse,
    GetClassificationTablesByClassificationTableIdError,
    ThrowOnError
  >({
    ...options,
    url: '/classification-tables/{classificationTableId}',
  });
};

export const getClassificationsEntriesByClassificationEntryId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetClassificationsEntriesByClassificationEntryIdData,
    ThrowOnError
  >
) => {
  return (options?.client ?? client).get<
    GetClassificationsEntriesByClassificationEntryIdResponse,
    GetClassificationsEntriesByClassificationEntryIdError,
    ThrowOnError
  >({
    ...options,
    url: '/classifications/entries/{classificationEntryId}',
  });
};
